// @flow
import React from 'react';
import { z } from 'zod';
import { Controller, useFormContext } from 'react-hook-form';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import { AspectRatio } from '../../aspect-ratio/aspect-ratio';

const zodSchema = z.object({
	url: z.string().url(),
	scrolling: z.boolean().optional(),
	autoplay: z.boolean().optional(),
	allowfullscreen: z.boolean().optional(),
});

export const EmbedBlock = props => {
	const { control, watch } = useFormContext();
	const watchedConfig = watch('config');
	const result = zodSchema.safeParse(watchedConfig);
	
	return (
		<React.Fragment>
			<Controller
				name="config.url"
				control={control}
				rules={{ required: true }}
				render={({ fieldState: { error }, field: { onChange, value } }) => (
					<TextField
						value={value}
						errorText={error ? 'Адрес обязателен для заполнения' : ''}
						onChange={onChange}
						floatingLabelText="Адрес iframe"
						fullWidth
						floatingLabelFixed={true}
					/>
				)}
			/>
			<Controller
				name="config.autoplay"
				control={control}
				render={({ field: { onChange, value } }) => <Checkbox label="Разрешить автовоспроизведение" onCheck={onChange} checked={value} />}
			/>
			<Controller
				name="config.allowfullscreen"
				control={control}
				render={({ field: { onChange, value } }) => <Checkbox label="Разрешить полный экран" onCheck={onChange} checked={value} />}
			/>
			<Controller
				name="config.scrolling"
				control={control}
				render={({ field: { onChange, value } }) => <Checkbox label="Отключить скроллинк" onCheck={onChange} checked={value} />}
			/>
			{result.success && (
				<div style={{ maxWidth: 875 }}>
					<div>Preview</div>
					<AspectRatio ratio="16/9">
						<iframe
							width="100%"
							height="100%"
							style={result.data.scrolling ? { overflow: 'hidden' } : undefined}
							scrolling={result.data.scrolling ? 'no' : undefined}
							allow={`${result.data.autoplay ? 'autoplay' : ''}`}
							src={result.data.url}
							allowFullScreen={result.data.allowfullscreen}
						/>

					</AspectRatio>
				</div>
			)}
		</React.Fragment>
	);
};



// WEBPACK FOOTER //
// src/components/configurable-blocks/parts/EmbedBlock.jsx